import {ActionReducerMapBuilder} from '@reduxjs/toolkit';
import {TimeslotsState} from '../stateTypes';
import {actions} from '../actions';
import {getPendingKeysOwnedByRequest} from '../utils';
import {datesForRange, dateKeyForDateTimeString} from '../dateTimeHelpers';
import {groupBy} from '@lib/utils';

export const extendWithConnectionWorkdaysReducers = (builder: ActionReducerMapBuilder<TimeslotsState>) => {
  builder
    .addCase(actions.fetchWorkdaysForConnections.pending, (state, action) => {
      for (const dateKey of datesForRange(action.meta.arg)) {
        state.connectionWorkdaysByDate[dateKey] = {
          status: 'pending',
          data: state.workdaysByDate[dateKey]?.data ?? null,
          requestId: action.meta.requestId,
        };
      }
    })
    .addCase(actions.fetchWorkdaysForConnections.fulfilled, (state, action) => {
      const workdaysByDate = groupBy(action.payload, (wd) => dateKeyForDateTimeString(wd.localStart));
      const pendingForThisRequest = getPendingKeysOwnedByRequest(
        datesForRange(action.meta.arg),
        state.connectionWorkdaysByDate,
        action.meta.requestId,
      );
      for (const dateKey of pendingForThisRequest) {
        state.connectionWorkdaysByDate[dateKey] = {
          status: 'fulfilled',
          data: workdaysByDate[dateKey] ?? [],
        };
      }
    })
    .addCase(actions.fetchWorkdaysForConnections.rejected, (state, action) => {
      const pendingForThisRequest = getPendingKeysOwnedByRequest(
        datesForRange(action.meta.arg),
        state.connectionWorkdaysByDate,
        action.meta.requestId,
      );
      for (const dateKey of pendingForThisRequest) {
        state.connectionWorkdaysByDate[dateKey] = {
          status: 'rejected',
          data: null,
          errorMessage:
            action.error.message ??
            `Something went wrong loading the workdays between ${action.meta.arg.to} and ${action.meta.arg.from} for connections`,
        };
      }
    });
};
